import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { contactFrom } from "../lib/contact";

export const WhatsAppButton = () => {
  const [num, setNum] = useState(contactFrom().whatsapp);
  useEffect(() => {
    api.get("/settings").then((r) => setNum(contactFrom(r.data).whatsapp)).catch(() => {});
  }, []);
  if (!num) return null;
  return (
    <a
      href={`https://wa.me/${num}`}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label="WhatsApp"
      className="fixed bottom-6 end-6 z-[65] w-13 h-13 flex items-center justify-center bg-[#25D366] rounded-full shadow-lg hover:scale-105 transition-transform"
      style={{ width: 54, height: 54 }}
    >
      <svg viewBox="0 0 32 32" width="28" height="28" fill="#fff"><path d="M16 3C9.4 3 4 8.4 4 15c0 2.1.6 4.1 1.6 5.9L4 29l8.3-1.6c1.7.9 3.6 1.4 5.7 1.4 6.6 0 12-5.4 12-12S22.6 3 16 3zm0 21.8c-1.8 0-3.5-.5-5-1.4l-.4-.2-3.6.7.7-3.5-.2-.4c-1-1.6-1.5-3.4-1.5-5.3 0-5.5 4.5-9.9 9.9-9.9 5.5 0 9.9 4.5 9.9 9.9.1 5.5-4.4 9.9-9.8 9.9zm5.5-7.4c-.3-.2-1.8-.9-2-1-.3-.1-.5-.2-.7.2s-.8 1-.9 1.1c-.2.2-.3.2-.6.1-.3-.2-1.3-.5-2.4-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6.1-.1.3-.3.4-.5.2-.2.2-.3.3-.5.1-.2 0-.4 0-.5s-.7-1.6-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.2.2 2.1 3.3 5.2 4.6.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.3-.3-.3-.6-.5z"/></svg>
    </a>
  );
};
